import { shouldScopePedidosToMedicoUser } from './medicoPedidosScope';

export const ALTA_RAPIDA_PEDIDO_PERMISSION = 'crear_pedido_alta_rapida';

/** Mismo criterio que el sidebar: solo permisos efectivos del usuario, sin bypass admin. */
export function userHasPermission(user, permissionCode, { permissionsLoading = false } = {}) {
  if (!permissionCode || permissionsLoading || !user) return false;
  if (!Array.isArray(user.permissions)) return false;
  return user.permissions.includes(permissionCode);
}

/** Permiso explícito o médico en bandeja (ver_pedido_recetas_medico sin derivación). */
export function canCreatePedidoAltaRapida(user, options = {}) {
  const { permissionsLoading = false } = options;
  if (permissionsLoading || !user) return false;
  if (userHasPermission(user, ALTA_RAPIDA_PEDIDO_PERMISSION, { permissionsLoading: false })) {
    return true;
  }
  return shouldScopePedidosToMedicoUser(user);
}